import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import SelectCustomer from "./SelectCustomer";
import { getCustomers } from "../../features/Cart/service/Customers.service";
import { getcart } from "../../features/Checkout/service/cart.service";
import { Link } from "react-router-dom";

function Proceedcustomer({ onCustomerChange }) {
  const [show, setShow] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);

  const openModal = async () => {
    setShow(true);
    setLoading(true);

    try {
      // Customers API se fresh data
      const customerResponse = await getCustomers();

      const customerList = Array.isArray(customerResponse)
        ? customerResponse
        : Array.isArray(customerResponse?.data)
        ? customerResponse.data
        : Array.isArray(customerResponse?.data?.data)
        ? customerResponse.data.data
        : [];

      setCustomers(customerList);

      // Current cart API se fresh customer
      const cartData = await getcart();

      const cartCustomer =
        cartData?.cartCustomer || {};

      const currentCustomerId =
        cartCustomer?.id ||
        cartCustomer?.customer_id;

      if (currentCustomerId) {
        const activeCustomer = customerList.find(
          (item) =>
            Number(item?.id) === Number(currentCustomerId) ||
            Number(item?.customer_id) ===
              Number(currentCustomerId)
        );

        setSelectedCustomer(
          activeCustomer || cartCustomer
        );
      } else {
        // Agar cart me customer nahi hai
        // to first customer select
        setSelectedCustomer(
          customerList.length
            ? customerList[0]
            : null
        );
      }
    } catch (error) {
      console.error(
        "Customer Load Error:",
        error
      );

      setCustomers([]);
      setSelectedCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerChange = (customer) => {
    if (!customer) return;

    // State only - localStorage me save nahi
    setSelectedCustomer(customer);

    // Parent ko selected customer bhejo
    if (onCustomerChange) {
      onCustomerChange(customer);
    }

    // Modal close
    setShow(false);
  };

  return (
    <>
      <Link
        onClick={(e) => {
          e.preventDefault();
          openModal();
        }}
        className="checkbutton"
        style={{ border:"none", backgroundColor:"transparent"}}
      >
        <i className="bi bi-pencil-square text-warning"></i>
      </Link>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        contentClassName="bg-transparent border-0 shadow-none"
      >
        <Modal.Body className="p-0 bg-transparent">
          {loading ? (
            <div className="text-center p-4 bg-white">
              Loading customers...
            </div>
          ) : (
            <SelectCustomer
              customers={customers}
              selectedCustomer={selectedCustomer}
              onChange={handleCustomerChange}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Proceedcustomer;